const _temp0 = require("./activity-3-part-2-scenario-church-group.jpg");
const _temp1 = require("./activity-3-part-2-scenario-employee.jpg");
const _temp2 = require("./activity-3-part-2-scenario-tourist.jpg");
module.exports = {
  "church-group": _temp0,
  "employee": _temp1,
  "tourist": _temp2
}